import {DocumentIcon} from '@heroicons/react/outline';

import {renderFile} from '@/utils/imageFiles';

type Props = {
  title: string;
  items: {url: string; name: string}[];
};

export const DocumentList = ({title, items}: Props) => (
  <div className="mt-6 bg-white dark:bg-transparent rounded-lg p-5 border border-gray-200 dark:border-gray-700">
    <div className="mb-4 flex items-center gap-2">
      <DocumentIcon className="text-blue-500 w-5 h-5" />
      <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">
        {title}
      </h3>
    </div>
    <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
      {items.length === 0 ? (
        <p>No documents uploaded</p>
      ) : (
        items.map((item, index) => (
          <div key={`${item.url}-${index}`} data-testid="uploaded-document">
            {renderFile(item.url, item.name)}
          </div>
        ))
      )}
    </div>
  </div>
);
